export default function getFirstArrayItem(array: any[]) {
  return array[0];
}
